import script from "./Introduce.vue?vue&type=script&setup=true&lang=js"
export * from "./Introduce.vue?vue&type=script&setup=true&lang=js"

import "./Introduce.vue?vue&type=style&index=0&id=3ad9ec32&lang=scss&scoped=true"

import exportComponent from "/tmp/tesla_data/tmp/apply_3091/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ad9ec32"]])

export default __exports__